// removed by extract-text-webpack-plugin
module.exports = {"story-container":"src-components-SingleClient-singleClientNews-___singleClientNews__story-container___lFfKr","image-container":"src-components-SingleClient-singleClientNews-___singleClientNews__image-container___nv3Fg","content-list":"src-components-SingleClient-singleClientNews-___singleClientNews__content-list___ZwI0Z","title":"src-components-SingleClient-singleClientNews-___singleClientNews__title___1OhwB","date":"src-components-SingleClient-singleClientNews-___singleClientNews__date___3jlnb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SingleClient/singleClientNews/singleClientNews.css
// module id = 1075
// module chunks = 0